import React from 'react';

const SmallBoxIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.90345 15.4103C7.93563 15.4264 7.96782 15.4425 8 15.4425C8.03218 15.4425 8.06437 15.4425 8.09655 15.4264L14.8874 11.7897C14.9517 11.7575 15 11.6931 15 11.6126V4.59655C15 4.58046 15 4.56437 15 4.54828V4.53218C15 4.51609 14.9839 4.51609 14.9839 4.5L14.9678 4.48391C14.9678 4.46782 14.9517 4.46782 14.9517 4.45172L14.9356 4.43563L14.9195 4.41954C14.9195 4.41954 14.9195 4.41954 14.9034 4.41954L8.09655 1.02414C8.03218 0.991954 7.96782 0.991954 7.91954 1.02414L1.11264 4.41954C1.04828 4.45172 1 4.51609 1 4.59655V11.5161C1 11.5966 1.03218 11.6609 1.09655 11.6931L7.90345 15.4103ZM1.4023 11.3874V4.91839L7.7908 8.12069V14.9115L1.4023 11.3874ZM14.5977 11.4678L8.2092 14.8954V8.12069L11.1379 6.65632V9.55287H11.5402V6.44713L14.5977 4.91839V11.4678ZM8 1.42644L14.3402 4.59655L11.4115 6.06092L11.3149 6.1092L5.26437 2.79425L8 1.42644ZM4.82989 3.00345L10.8966 6.31839L8 7.76667L1.65977 4.59655L4.82989 3.00345Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.8"
      />
    </svg>
  );
};

export default SmallBoxIcon;
